import type { CoinSymbol } from '@asia/shared';
import { FigIcon } from './FigIcon';

/** Brand coin marks exported from the Figma design (Tether teal, Tron red). */
export function CoinIcon({ symbol, size = 40 }: { symbol: CoinSymbol; size?: number }) {
  return <FigIcon name={symbol === 'USDT' ? 'usdt' : 'trx'} size={size} />;
}
